import AppPageTemplate from '@/components/templates/AppPageTemplate';
import { createFileRoute, Outlet } from '@tanstack/react-router';

const PeerSupportLayout = () => {
  return (
    <AppPageTemplate>
      <Outlet />
    </AppPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_peer-support')({
  component: PeerSupportLayout,
});
